import React from "react";
import { useTranslation } from "react-i18next";
import InstructionPageShell from "./InstructionPageShell";

export default function InstructionTreatmentPlan() {
  const { t } = useTranslation("instructions");

  return (
    <InstructionPageShell
      blockTitle={t("treatmentPlan.blockTitle")}
      pageTitle={t("treatmentPlan.pageTitle")}
      body={t("treatmentPlan.body")}
    />
  );
}
